import GetApp from 'components/getApp/GetApp';
import { RouteConfig } from '../type';

const appRoutes: RouteConfig[] = [
    { path: '', element: <GetApp />, pageTitle: 'Get the App' },
    { path: '*', element: <GetApp />, pageTitle: 'Get the App' },
];

export default appRoutes;
